import { __extends } from "tslib";
import LanguageDetectorNames from "../constants/LanguageDetectorNames";
import AbstractDetector from "./AbstractDetector";
var ForcedLanguageDetector = /** @class */ (function (_super) {
    __extends(ForcedLanguageDetector, _super);
    function ForcedLanguageDetector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * The detection logic for this class, returns the language string or null when nothing is found.
     *
     * @returns {(string|null)} The language or null if the detector could note validate the language.
     */
    ForcedLanguageDetector.prototype.detect = function () {
        var language = new URLSearchParams(window.location.search).get("hcLang");
        var detectedForcedLangByUrl = _super.prototype.detect.call(this, language);
        if (!!detectedForcedLangByUrl) {
            return detectedForcedLangByUrl;
        }
    };
    ForcedLanguageDetector.prototype.getName = function () {
        return LanguageDetectorNames.ForcedLanguage;
    };
    return ForcedLanguageDetector;
}(AbstractDetector));
export default ForcedLanguageDetector;
//# sourceMappingURL=ForcedLanguageDetector.js.map